import '../scss/main.scss';
import { initNav } from './nav';
import { initPhotoFaders } from './photo-fader';
import { initStreamStatus } from './stream-status';
import { initLetters } from './letters';
import { initHeroLogo } from './logo-hero';
import { initCurtain } from './curtain';
import { initVideoPlayer } from './video-player';

initNav();
initPhotoFaders();
initStreamStatus();
initLetters();
initHeroLogo();
initCurtain();
initVideoPlayer();
